import {
  ADD_PRODUCT,
  ADD_QUANTITY,
  ADD_TO_CART,
  DELETE_PRODUCT_FROM_CART,
  REMOVE_QUANTITY,
} from "./actionTypes";
import initialState from "./initialState";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PRODUCT:
      return {
        ...state,
        products: [...state.products, action.payload],
        cart: [...state.cart],
      };

    case ADD_TO_CART:
      const { product_id, title, category, price, url, total_product } =
        action.payload || {};
      return {
        ...state,
        products: [...state.products].map((pd) =>
          pd.product_id === product_id
            ? { ...pd, quantity: pd.quantity - 1 }
            : pd
        ),
        cart: [
          ...state.cart,
          {
            product_id,
            title,
            category,
            price,
            url,
            total_product,
            quantity: 1,
          },
        ],
      };

    case ADD_QUANTITY:
      return {
        ...state,
        products: [...state.products].map((pd) =>
          pd.product_id === action.payload
            ? { ...pd, quantity: pd.quantity - 1 > 0 ? pd.quantity - 1 : 0 }
            : pd
        ),
        cart: [...state.cart].map((item) => {
          if (item.product_id === action.payload) {
            return {
              ...item,
              quantity:
                item.quantity + 1 <= item.total_product
                  ? item.quantity + 1
                  : item.total_product,
            };
          } else {
            return item;
          }
        }),
      };

    case REMOVE_QUANTITY:
      return {
        ...state,
        products: [...state.products].map((pd) =>
          pd.product_id === action.payload
            ? {
                ...pd,
                quantity:
                  pd.quantity + 1 < pd.total_product
                    ? pd.quantity + 1
                    : pd.quantity,
              }
            : pd
        ),
        cart: [...state.cart].map((item) => {
          if (item.product_id === action.payload) {
            return {
              ...item,
              quantity: item.quantity - 1 > 0 ? item.quantity - 1 : 1,
            };
          } else {
            return item;
          }
        }),
      };

    case DELETE_PRODUCT_FROM_CART:
      // add quantity after delete
      return {
        ...state,
        products: [...state.products],
        cart: [...state.cart].filter(
          (item) => item.product_id !== action.payload
        ),
      };

    default:
      return state;
  }
};

export default reducer;
